<template>
    <div>
        <Form ref="formValidate" :model="formItem" :label-width="80">
            <Row>
                <Col span="24">
                    <Col span="4">
                        <FormItem label="选择门店" prop="store_id">
                            <!-- <Select v-model="formItem.store_id">
                                <Option v-for="item in storeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select> -->
                            <dropCheckBox
                                type="delayStoreList"
                                :checkAllGroup="formItem.store_id"
                                :checkboxData="storeList"
                                placeholder="请选择"
                                :checkedValue="signStoreCheckedShowValue"
                                @delayStoreList_even="signStoreList">
                            </dropCheckBox>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="录入时间" prop="enter_time">
                            <DatePicker v-model="formItem.enter_time" type="daterange" placeholder="请选择" style="display: block" placement="bottom-end" @on-change="changeEnterTime"></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="渠道" prop="enter_department_id">
                            <Select v-model="formItem.enter_department_id" placeholder="请选择部门" @on-change="changeChannel">
                                <Option v-for="item in departmentChannel" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="3">
                        <FormItem :label-width="0" prop="channel_id">
                            <Select v-model="formItem.channel_id" filterable placeholder="请选择渠道">
                                <Option v-for="item in channel" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4">
                        <FormItem label="跟进人" prop="follow_department_id">
                            <Select v-model="formItem.follow_department_id" placeholder="请选择部门" @on-change="changeFollowr">
                                <Option v-for="item in departmentFollow" :key="item.id" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="3">
                        <FormItem :label-width="0" prop="follow_user_id">
                            <Select v-model="formItem.follow_user_id" placeholder="请选择跟进人">
                                <Option v-for="item in followr" :key="item.id" :value="item.id">{{item.user_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="分配时间" class="mb-10" prop="allot_time">
                        <DatePicker v-model="formItem.allot_time" type="daterange" placeholder="请选择" style="display: block"></DatePicker>
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="关键字" prop="keywords">
                        <Input v-model="formItem.keywords" placeholder="姓名/手机"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <Button type="primary" style="margin-left:5px" @click="search">查询</Button>
                    <Button type="primary" @click="reset">清空筛选</Button>
                    <Button type="primary"   @click="excelCustomer">导出客户Excel</Button>
                </Col>
            </Row>
        </Form>
        <div style="width:100%">
            <Table ref="table" stripe :loading="loading" border :columns="t_head" :data="t_data" :height="tableHeight"></Table>
            <div style="margin-top:20px;display:flex;justify-content:flex-end">
                <Page :total="pagination.total" :page-size="pagination.per_page" show-total show-elevator show-sizer  @on-page-size-change="changeLimit"  @on-change="changePages" :transfer="true" :page-size-opts="pageSizeOpts"/>
            </div>
        </div>
        <!-- 导出客户 -->
        <customerExcel
        :excelTitle='excelTitle'
        :excelSteps="excelSteps"
        :downloadLink="downloadLink"
        :customerExcelShow="customerExcelShow"
        @customerExcelEven="customerExcelEven">
        </customerExcel>
    </div>
</template>
<script>
import dropCheckBox from "@/commonTmp/dropCheckBox"//多选下拉框
import customerExcel from "@/commonTmp/CRM/CRM_customerExcel"//客户导出
export default {
    name:'delayFollowUpRecord',
    components:{
        customerExcel,
        dropCheckBox
    },
    data(){
        return{
            signStoreCheckedShowValue:window.agent_info.store_name,
            excelTitle:'',
            excelSteps:1,
            downloadLink:'',
            customerExcelShow:false,
            tableHeight: 500,
            pageSizeOpts:[50,60,70,80,90,100],
            loginInfo:window.agent_info,
            loading:false,
            formItem:{
                limit:50,
                store_id:[window.agent_info.store_id],
                enter_time:[],
                enter_department_id:"",
                channel_id:"",
                follow_department_id:"",
                follow_user_id:"",
                page:1,
                allot_time:[]
            },
            t_head: [
                {
                    width: 60,
                    align: 'center',
                    title:"序号",
                    render: (h,params) => {
                        return h('span',
                        (params.index + 1) + (this.pagination.per_page * (this.pagination.current_page-1)))
                    }
                },
                {
                    title: '客户名称',
                    key: 'member_name',
                    align: 'center',
                },
                {
                    title: '手机号',
                    key: 'member_phone',
                    align: 'center',
                },
                {
                    title: '跟进人',
                    key: 'follow_user',
                    align: 'center',
                },
                {
                    title: '跟进人所属门店',
                    key: 'store',
                    align: 'center',
                },
                {
                    title: '录入时间',
                    key: 'channel',
                    align: 'center',
                    render: (h, params) => {
                        let channel = params.row.channel
                        let html=""
                        for(let item of channel){
                            html+=item.enter_time+"\n"
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '录入渠道',
                    key: 'channel',
                    align: 'center',
                    render: (h, params) => {
                        let channel = params.row.channel
                        let html=""
                        for(let item of channel){
                            html+=item.enter_channel+"\n"
                        }
                        return h('div', [
                            h('div', {
                            }, html)
                        ]);
                    }
                },
                {
                    title: '分配人',
                    key: 'assign_user_name',
                    align: 'center',
                },
                {
                    title: '分配时间',
                    key: 'allocate_time',
                    align: 'center',
                },
                {
                    title: '第一次回访时间',
                    key: 'first_visit_time',
                    align: 'center',
                },
            ],
            t_data: [],
            pagination:{},
            storeList:[],
            // departmentList:[],
            departmentChannel:[],
            departmentFollow:[],
            channel:[],
            followr:[]
        }
    },
    created(){
        this.apiStoreAll()
        this.visitDepartmentChannel()
        this.visitDepartmentFollow()
    },
    mounted(){
        // this.formItem.store_id = this.loginInfo.store_id
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220
        this.apiGetList()
    },
    methods:{
        //监听选择门店
        signStoreList(data,value){
            console.log(data)
            this.formItem.store_id = data
            this.signStoreCheckedShowValue = value
        },
        //导出客户
        excelCustomer(){
            this.excelTitle = '导出客户Excel'
            this.excelSteps = 1
            this.customerExcelShow = true
        },
        apiStoreAll(){
            serve.fetchGet(api.visitStore,{}).then(data => {
                console.log(data)
                this.storeList = data.data
            }).catch((error)=>{
                if(error.response.data.status_code == 405){
                    let getCurrentStore = [
                        {
                            id:window.agent_info.store_id,
                            name:window.agent_info.store_name
                        }
                    ]
                    this.storeList = getCurrentStore
                    this.formItem.store_id=[window.agent_info.store_id]
                    this.signStoreCheckedShowValue=window.agent_info.store_name
                }
                this.$Message.error(error.response.data.message);
            })
        },
        // apiDepartmentAll(){
        //     serve.fetchGet(api.departmentAll,{}).then(data => {
        //         console.log(data)
        //         this.departmentList = data.data
        //     }).catch((error)=>{
        //         this.$Message.error(error.response.data.message);
        //     })
        // },
        //渠道部门
        visitDepartmentChannel(){
            serve.fetchGet(api.visitDepartmentChannel,{}).then(data => {
                console.log(data)
                this.departmentChannel = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //跟进人部门
        visitDepartmentFollow(){
            serve.fetchGet(api.visitDepartmentFollow,{}).then(data => {
                console.log(data)
                this.departmentFollow = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiChannelAll(id){
            serve.fetchGet(api.visitChannel,{department_id:id}).then(data => {
                console.log(data)
                this.channel = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiFollowr(department_id,store_id){
            let params={
                department_id:department_id,
                store_id:store_id
            }
            serve.fetchGet(api.visitAgent,params).then(data => {
                console.log(data)
                this.followr = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiGetList(excel_title,excel_params){
            let params = {
                store_id:this.formItem.store_id,
                channel_id:this.formItem.channel_id,
                enter_department_id:this.formItem.enter_department_id,
                enter_time_start:this.formItem.enter_time.length == 0 ? '' : util.dateFormat(this.formItem.enter_time[0]),
                enter_time_end:this.formItem.enter_time.length == 0 ? '' : util.dateFormat(this.formItem.enter_time[1]),
                keywords:this.formItem.keywords,
                follow_department_id:this.formItem.follow_department_id,
                follow_user_id:this.formItem.follow_user_id,
                page:this.formItem.page,
                limit:this.formItem.limit,
                allot_time_start:this.formItem.allot_time.length == 0 ? '' : util.dateFormat(this.formItem.allot_time[0]),
                allot_time_end:this.formItem.allot_time.length == 0 ? '' : util.dateFormat(this.formItem.allot_time[1]),
            }
            let url = api.getDelayFollow
            if(excel_params){
                this.$Message.loading({
                    content: '正在获取导出链接',
                    duration:100
                })
                url = api.exportDelayFollow
                if(excel_params.value == 1){
                    params.email = excel_params.mail//按筛选条件导出传参
                }else if(excel_params.value == 2){
                    params = {
                        email:excel_params.mail//按全部导出传参
                    }
                }
            }else{
                this.loading = true
            }
            serve.fetchGet(url,params).then(data => {
                console.log(data)
                if(excel_params){
                    this.$Message.destroy()
                    this.downloadLink = data.url
                    this.excelSteps = 2
                    this.customerExcelShow = true
                    return
                }
                this.t_data = data.data
                this.pagination = data.meta.pagination
                this.loading = false
            }).catch((error)=>{
                this.loading = false
                this.$Message.destroy()
                this.$Message.error(error.response.data.message);
            })
        },
        changeLimit(val){
            this.formItem.limit=val
            this.apiGetList()
        },
        changeEnterTime(date){
            console.log(date)
        },
        changeChannel(id){
            this.formItem.channel_id = ""
            this.apiChannelAll(id)
        },
        changeFollowr(department_id){
            this.formItem.follow_user_id = ""
            this.apiFollowr(department_id,this.formItem.store_id)
        },
        changePages(page){
            this.formItem.page = page
            this.apiGetList()
        },
        search(){
            this.formItem.page = 1
            this.apiGetList()
        },
        reset(){
            this.$refs.formValidate.resetFields()
            this.formItem.page = 1
            this.signStoreCheckedShowValue=window.agent_info.store_name,
            this.formItem.store_id = [window.agent_info.store_id]
            this.apiGetList()
        },
        customerExcelEven(val,is_export,params,title){
            this.customerExcelShow = val
            if(is_export){
                this.formItem.page = 1
                this.apiGetList(title,params)
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/Crm/ReturnManagement/delayFollowUpRecord.vue